import { DealPartnerContact, SearchResult, Guid, NaicsCode, CompanySubscription, DealFundingLender } from '.';

export interface Deal {
	guid: string;
	companyGuid: string;
	companyName: string;
	dataRoomGuid: string;
	hubSpotId: string;
	createdOn: string;
	financialStartDate: string;
	modifiedOn: string;
	targetFundingDate: string;
	isAsapTargetDate: boolean;
	requestDescription: string;
	pricePriority: string;
	covenantPriority: string;
	maturityPriority: string;
	amortizationPriority: string;
	amountPriority: string;
	industryExpPriority: string;
	localBankPriority: string;
	bankExperiencePriority: string;
	lowerEquityPriority: string;
	avoidPersonalGuaranteePriority: string;
	totalRequestedAmount: number;
	termSheetReceiptDate: string;
	yearsInOperation: number;
	investorOwned: boolean;
	numberEmployees: number;
	mostRecentFiscalYearRevenue: number;
	haveRecurringRevenue: boolean | null;
	monthlyRecurringRevenue: number;
	annuallyRecurringRevenue: number;
	mostRecentTtmEbitda: number;
	debtScheduleJson: string;
	performaDebtIncludingFacility: number;
	amountFunded: number;
	dateFunded: Date | null;
	isLoanRequestCompleted: boolean;
	companyClarifications: string;
	isCompanyCompleted: boolean;
	financialClarifications: string;
	isFinancialCompleted: boolean;
	lenderClarifications: string;
	isLenderCompleted: boolean;
	isQuestionsCompleted: boolean;
	companyNotes: string;
	lenderNotes: string;
	requestNotes: string;
	dealName: string;
	expirationDate: string;
	isContactsCompleted: boolean;
	requestedLenderOn: string;
	isDealStructureCompleted: boolean;
	isLockedStructures: boolean;
	nonUsBasedEmployees: number;
	isLegacyView: boolean;
	acquisitionYearsInOperation: number;
	hasLegalCouncel: boolean;
	legalFirmName: string;
	institutionalInvestor: boolean | null;
	acquisitionInstitutionalInvestor: boolean | null;
	companyFinancialNotes: string;
	acquisitionFinancialNotes: string;
	narrative: string;
	principalDetails: string;
	additionalInformationRequest: string;
	additionalInformationResponse: string;
	isDebtSectionCompleted: boolean;
	isSettingsSectionCompleted: boolean;
	hasExcludedLenders: boolean;
	hasReducedFeeLenders: boolean;
	companyLocatedInRuralArea: boolean;
	postalCode: string;
	borrowerSubmittedLoanApplicationOn: string;
	enteredMarketOn: string;
	currency: string;
	acquisitionCurrency: string;
	address1: string;
	city: string;
	acquisitionAddress1: string;
	acquisitionCity: string;
	acquisitionPostalCode: string;
	acquisitionUsBasedEmployees: number;
	acquisitionNonUsBasedEmployees: number;
	customerPurchaseOrders: boolean | null;
	purchaseOrderAverageMonthlyCost: number | null;
	acquisitionCustomerPurchaseOrders: boolean | null;
	acquisitionPurchaseOrderAverageMonthlyCost: number | null;
	welcomeEmailSentDate: string;
	applicationCompleteOverride: boolean;
	isExecutiveSummaryComplete: boolean;
	dealClosedDiscardedReason: DealClosedDiscardedReason | null;
	dealClosedDiscardedNotes: string;
	dealPausedReason: DealClosedDiscardedReason | null;
	dealPausedNotes: string;
	followUpDate: Date | null;
	includeExecutiveSummary: boolean;
	customerConcentrationsMoreThan10Percent: boolean;
	customerConcentrationDetails: string;
	acquisitionCustomerConcentrationsMoreThan10Percent: boolean;
	acquisitionCustomerConcentrationDetails: string;
	companyType: CompanyTypes;
	dealStatus: DealStatus;
	natureOfBuyer: NatureOfBuyer;
	runwayLeftInMonths: RunwayLeftInMonths;
	businessSalesType: BusinessSalesType;
	transactionType: TransactionType;
	companyFinancialStatementType: FinancialStatementType;
	acquisitionHaveRecurringRevenue: boolean | null;
	acquisitionRunwayLeftInMonths: RunwayLeftInMonths;
	acquisitionBusinessSalesType: BusinessSalesType;
	acquisitionEvaluationStage: EvaluationStage;
	acquisitionFinancialStatementType: FinancialStatementType;
	state: StateDto | null;
	naicsCode: NaicsCode | null;
	companyIndustry: IndustryDto | null;
	acquisitionState: StateDto | null;
	acquisitionIndustry: IndustryDto | null;
	acquisitionNaicsCode: NaicsCode;
	transactionManager: Guid | null;
	secondaryTransactionManager: Guid | null;
	lenderRelationsManager: Guid | null;
	generateLoanApplicationPdf: boolean;
	dealPartner: SearchResult | null;
	dealPartnerContact: DealPartnerContact | null;
	businessOwnershipNarrative: string;
	lastMatchingUpdateOn: Date | null;
	lastMatchingUpdateString: string;
	isPendingMatchingUpdate: boolean;
	isLenderFinanceDeal: boolean;
	isFloorplanFinanceDeal: boolean;
	hasSelectedPreference: boolean;
	hasCompanySubscription: boolean;
	hasParentCompany: boolean;
	isCompanySubscriptionRefinance: boolean;
	companySubscriptionRefinanceIncrementalAmount: number | null;
	hasGeneratedSuccessFeeInvoice: boolean;
	countryType: CountryTypes;
	acquisitionCountryType: CountryTypes | null;
	isEditingCreditAnalysis: boolean;
	isDirectIntroDeal: boolean;
	hasLaunched: boolean;
	excludedLenderCount: number;
	reducedFeeLenderCount: number;
	showMatchingBlankIssue: boolean;
	isClosedDeal: boolean;
	contractSignedOrLater: boolean;
	b2bPercent: number | null;
	b2cPercent: number | null;
	b2gPercent: number | null;
	acquisitionB2bPercent: number | null;
	acquisitionB2cPercent: number | null;
	acquisitionB2gPercent: number | null;
	matchingProcessStartedOn: Date | null;
	matchingFailedUpdated: boolean;
	fundingLenders: DealFundingLender[];
	salesPerson: Guid | null;

	// deal success story
	reasonForUsingCerebro?: string;
	topDealChallenge1?: string;
	topDealChallenge2?: string;
	topDealChallenge3?: string;
	whySelectedTermSheet?: string;
	dealSummary?: string;
	marketingOutreachOptOut: boolean;
	willingReferral: boolean;
	isRawLead: boolean;
	isRawLeadVisible: boolean;
}

export interface SimilarDealReport {
	items: DealSearchItem[];
	matchedSummary: SimilarDealSummary;
	otherSummary: SimilarDealSummary;
}

export interface DealSearchItem {
	id: number;
	guid: string;
	dataRoomGuid: string;
	companyName: string;
	dealStartDate: string;
	dealStatus: DealStatus;
	totalTermSheets: number;
	dealSize: number;
	ttmEbitda: number;
	ttmRevenue: number;
	leverageRatio: number;
	industryName: string;
	stateCode: string;
	industryMatch: number;
	institutionLendersAccepted: number;
	dealLaunched: boolean;
	isClosedFunded: boolean;
	amountFunded: number | null;
	daysToTermSheet: number | null;
}

export interface SimilarDealSummary {
	industryMatch: boolean;
	dealsLaunched: number;
	termSheetsReceived: number;
	totalClosed: number;
	totalFundedAmount: number;
	averageLaunchToTermSheetDays: number;
}

export interface StateDto {
	code: string;
	name: string;
	country: string;
	countryCode: string;
}

export interface IndustryDto {
	guid: string;
	name: string;
}

export interface UpdateDealDto
	extends Omit<
		Partial<Deal>,
		| 'state'
		| 'naicsCode'
		| 'companyIndustry'
		| 'acquisitionState'
		| 'acquisitionNaicsCode'
		| 'acquisitionIndustry'
		| 'dealPartner'
		| 'dealPartnerContact'
		| 'hasSelectedPreference'
	> {
	naicsCode?: string;
	stateCode?: string;
	countryCode?: string;
	companyIndustryGuid?: string;

	acquisitionNaicsCode?: string;
	acquisitionStateCode?: string;
	acquisitionCountryCode?: string;
	acquisitionIndustryGuid?: string;
	dealPartnerContactGuid?: string | null;
	sourcePage?: string | null;
}

export type CountryTypes = keyof typeof CountryTypeMap;
export const CountryTypeMap = {
	UnitedStates: 'United States',
	Canada: 'Canada',
	Mexico: 'Mexico',
	Brazil: 'Brazil',
	Europe: 'Europe',
	Other: 'Other',
};

export type CompanyTypes = keyof typeof CompanyTypeMap;

export const CompanyTypeMap = {
	Unknown: 'Unknown',
	Corporation: 'Corporation',
	Scorp: 'S-Corp',
	NonProfit: 'Non-Profit',
	LLC: 'LLC',
	Sole_Proprietor: 'Sole Proprietor',
	Partnership: 'Partnership',
	Other: 'Other',
};

export const DealStatuses = {
	Started: 'Started',
	Accepted: 'Accepted',
	Declined: 'Declined',
	MoreInfoNeeded: 'More Info Needed',
	ContractSigned: 'Contract Signed',
	Pending: 'Ready for Launch',
	ReadyForReview: 'Submitted',
	Active: 'Deal Launched',
	ActiveClosing: 'Underwriting Diligence',
	TermSheetIssued: 'Term Sheets Issued',
	ClosedFunded: 'Closed-Funded',
	ClosedDiscarded: 'Closed-Lost',
	Paused: 'Paused',
	Inactive: 'Inactive',
};

export type DealStatus = keyof typeof DealStatuses;

export type NatureOfBuyer =
	| 'NotSelected'
	| 'ExistingOwner'
	| 'IndividualNonExistingOwner'
	| 'FundedSponsor'
	| 'NonFundedSponsor'
	| 'Strategic';

export type RunwayLeftInMonths = keyof typeof RunwayLeftInMonthsMap;

export const RunwayLeftInMonthsMap = {
	NotSelected: 'Select',
	Zero: 'None',
	One: '1 month or less',
	Two: '2 months',
	Three: '3 months',
	Four: '4 months',
	Five: '5 months',
	Six: '6 months',
	SevenToTwelve: '7 - 12 months',
	TwelvePlus: '12+ months',
	CashFlowPositive: 'Cash Flow Positive',
};

export type BusinessSalesType = keyof typeof BusinessSalesTypeMap;

export const BusinessSalesTypeMap = {
	NotSelected: 'Not Selected',
	B2B: 'Other Businesses - B2B',
	B2C: 'Consumers - B2C',
	B2G: 'Government Entities - B2G',
};

export const CurrencyTypeMap = {
	NotSelected: 'Not Selected',
	Us: 'USD',
	Uk: 'GBP',
	Au: 'AUD',
	Ca: 'CAD',
	Eu: 'EUR',
	Hk: 'HKD',
};

export type TransactionType = 'None' | 'Asset' | 'StockSale';

export type FinancialStatementType = keyof typeof FinancialStatementTypeMap;

export const FinancialStatementTypeMap = {
	None: 'None',
	Audited: 'Audited',
	Reviewed: 'Reviewed',
	Compiled: 'Compiled',
	CompanyPrepared: 'Company Prepared',
	TaxReturns: 'Tax Returns',
};

export type EvaluationStage = 'None' | 'LoiSigned' | 'LoiSubmitted' | 'LoiNegotiation' | 'EarlyStages';

export type CurrencyType = 'USD' | 'GBP' | 'AUD' | 'CAD' | 'EUR' | 'HKD';

export type DealClosedDiscardedReason = keyof typeof DealClosedDiscardedReasonMap;
export const DealClosedDiscardedReasonMap = {
	AcquisitionTargetNotViable: 'Acquisition target no longer viable',
	BorrowerAltCapital: 'Borrower found alternative capital',
	BorrowerNotPursuingFinancing: 'Borrower has decided to not pursue financing at this time',
	DealNotViable: 'Deal is not viable right now',
	NoTermSheetsCerebroLenders: 'No term sheets returned from Cerebro lenders',
	OtherLenderBetterTerms: 'Other lender provided better terms than Cerebro lenders',
	ProcessTooSlow: 'Our process too slow- received term sheets elsewhere',
	Unresponsive: 'Unresponsive',
	BorrowerNotAgreeingToTerms: `Borrower didn't agree to lender's terms`,
	DeletedDeal: 'Deleted Deal',
	BorrowerAltLender: 'Borrower already started process with other lenders',
	CerebroNotPursuingDeal: `Cerebro doesn't want to pursue this type of deal`,
	ValueNotInPlatform: `Doesn't see value in the platform`,
	NoCurrentNeed: 'No current need',
	PricingTooHigh: 'Pricing too high',
	UsingBroker: 'Using a broker',
	Intermediary: 'Went with another intermediary',
	WillNeverLeaveBank: 'Will never leave their bank',
	Exclusivity: `Won't agree to Exclusivity`,
	Covid: 'COVID related impacts',
};

export const isDealActive = (deal: Deal | null | undefined): boolean => {
	if (!deal) return false;

	return (
		deal.dealStatus == 'Active' ||
		deal.dealStatus == 'ActiveClosing' ||
		deal.dealStatus == 'Paused' ||
		deal.dealStatus == 'ContractSigned' ||
		deal.dealStatus == 'TermSheetIssued'
	);
};

export const isDealPending = (deal: Deal | null | undefined): boolean => {
	if (!deal) return false;

	return (
		deal.dealStatus == 'ReadyForReview' ||
		deal.dealStatus == 'Started' ||
		deal.dealStatus == 'Accepted' ||
		deal.dealStatus == 'MoreInfoNeeded' ||
		deal.dealStatus == 'Pending'
	);
};
